import { Checkbox } from '@ardoq/forms';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import styled from 'styled-components';
import { colors, space, s8 } from '@ardoq/design-tokens';
import { Text } from '@ardoq/typography';

type InvertCheckboxProperties = {
  isInverted: boolean;
  onChange: (isInverted: boolean) => void;
};
export const InvertCheckbox = ({
  isInverted,
  onChange,
}: InvertCheckboxProperties) => (
  <CheckboxWrapper>
    <Checkbox
      dataTestId="isInverted-checkbox"
      isChecked={isInverted}
      onChange={() => onChange(!isInverted)}
    >
      <VisuallyHidden>
        {isInverted ? 'Inverted ' : 'Not inverted '}
      </VisuallyHidden>
      Inverse
    </Checkbox>
  </CheckboxWrapper>
);

export const BottomRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.xsmall};

  &:not(:last-child) {
    margin-bottom: ${space.small};
  }
`;

export const PopoverSectionTitle = styled(Text).attrs({
  variant: 'text2Bold',
  color: 'textModerate',
  as: 'div',
})`
  margin-bottom: ${space.xsmall};
  font-weight: 600;
`;

type PopoverValueLineProps = {
  $isHidden?: boolean;
};
export const PopoverValueLine = styled.div<PopoverValueLineProps>`
  display: flex;
  align-items: center;
  gap: ${space.small};
  color: ${colors.textDefault};
  opacity: ${({ $isHidden }) => ($isHidden ? 0.32 : 1)};
`;

export const PopoverValue = styled.span`
  min-width: 0;
`;

type ColorSwatchProps = {
  $color: string;
  $isHidden?: boolean;
};
export const ColorSwatch = styled.span<ColorSwatchProps>`
  width: 12px;
  height: 12px;
  background: ${({ $color }) => $color};
  border-radius: 2px;
  border: 1px solid rgba(2, 6, 12, 0.08);
  flex-shrink: 0;
  opacity: ${({ $isHidden }) => ($isHidden ? 0.32 : 1)};
`;

const CheckboxWrapper = styled.div`
  margin-left: auto;
  margin-top: ${s8};
`;
